export function getQueryParam(url: string, paramName: string): string | null {
  const queryStart = url.indexOf('?')
  if (queryStart === -1) {
    return null
  }

  const queryString = url.substring(queryStart + 1)
  const params = queryString.split('&')

  for (const param of params) {
    const equalIndex = param.indexOf('=')
    if (equalIndex === -1) {
      continue
    }

    const key = param.substring(0, equalIndex)
    const value = param.substring(equalIndex + 1)

    if (key === paramName) {
      return value
    }
  }

  return null
}

export function extractRouteName(route: string): string {
  let result = route

  // Remove "lang-" prefix if the route starts with it
  if (result.startsWith('lang-')) {
    result = result.replace(/^lang-/, '')
  }

  // Replace standalone "lang" word
  result = result.replace(/\blang\b/g, '')

  return result
}
